import { selectors as sessionSelectors } from 'store/session';

export const isSupplier = (state) => {
  return sessionSelectors.isSupplier(state);
};
